// hooks/useScrollLock.js
import { useEffect } from "react";

export default function useScrollLock(ref, enabled) {
  useEffect(() => {
    const el = ref?.current;
    if (!el) return;

    const prevOverflow = el.style.overflowY;
    const prevTouchAction = el.style.touchAction;

    if (enabled) {
      /**
       * The "hidden" option of the overflow property
       *    The content that extends beyond the elements box gets clipped and becomes invisible
       *    No scrolling mechanism is provided.
       * The "none" option of the touchAction prorty
       *    this disables all browser-handled zooming and panning on the element
       */
      el.style.overflowY = "hidden";
      el.style.touchAction = "none";
      // Block wheel/touchmove bubbling
      /**
       * We add event listeners for scrolling actions
       * We register them as passive: false, because this tells the browser not to ignore preventDefault.
       * We run preventDefault on the event, so that what it does by default is not done
       *    So it stops the scrolling (for Wheel) and panning (for touchmove), i.e. the defaullt action
       */
      const block = (e) => e.preventDefault();
      el.addEventListener("wheel", block, { passive: false });
      el.addEventListener("touchmove", block, { passive: false });

      return () => {
        el.style.overflowY = prevOverflow;
        el.style.touchAction = prevTouchAction;
        el.removeEventListener("wheel", block);
        el.removeEventListener("touchmove", block);
      };
    } else {
      el.style.overflowY = prevOverflow || "auto";
      el.style.touchAction = prevTouchAction || "auto";
    }
  }, [ref, enabled]);
}
